module.exports = __webpack_public_path__ + "media/triangle.ddf20351.mp4";